import { render, staticRenderFns } from "./JoinPartner.vue?vue&type=template&id=b9e3f126&scoped=true&"
import script from "./JoinPartner.vue?vue&type=script&lang=js&"
export * from "./JoinPartner.vue?vue&type=script&lang=js&"
import style0 from "./JoinPartner.vue?vue&type=style&index=0&id=b9e3f126&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9e3f126",
  null
  
)

export default component.exports